<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item label="保险公司">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-model="queryParam.insurerNumber"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="被保人">
              <a-input placeholder="请录入被保险人" v-model="queryParam.insured"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="业务类型">
              <j-dict-select-tag
                placeholder="请选择业务类型"
                v-model="queryParam.businessType"
                :options="newBusinessTypeDictOptions"
                >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <a-form-item label="业绩状态" >
              <a-select v-model="queryParam.status" placeholder = "请选择" allowClear>
                <a-select-option value="4">已提交</a-select-option>
                <a-select-option value="11">已确认</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item label="项目名称">
                <j-dict-select-tag type="list" v-model="queryParam.project" dictCode="bms_project" placeholder="请选择项目"/>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="经纪人">
                <j-search-select-tag
                  placeholder="请选择经纪人"
                  v-model="queryParam.createBy"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md="5" :sm="6">
              <a-form-item label="保单号" >
                <a-input v-model="queryParam.policy" placeholder="请输入保单号"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="保单起期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.insuranceStartRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onStartDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="保单讫期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.insuranceEndRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onEndDateChange"
                />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
<!--              <a-button type="primary" @click="batchConfirm('11')" v-has="'businessInfoComplete:batchConfirm'">批量确认</a-button>
              <a-button type="primary" @click="batchConfirm('10')" v-has="'businessInfoComplete:batchSendBack'">批量退回</a-button>-->
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <a style="margin-left: 24px" @click="batchConfirm('11')" v-if="selectedRowKeys.length > 0"  v-has="'businessInfoComplete:batchConfirm'">批量确认</a>
        <a style="margin-left: 24px" @click="batchAudit" v-if="selectedRowKeys.length > 0"  v-has="'businessInfoComplete:batchToAudit'">批量推送开票</a>
        <a style="margin-left: 24px" @click="batchConfirm('2')" v-if="selectedRowKeys.length > 0"  v-has="'businessInfoComplete:batchSendBack'">批量退回</a>

        <span style="margin-left: 60px" >金额单位：元</span>
        <span style="margin-left: 24px" >保费合计：{{premiumTotal}}</span>
        <span style="margin-left: 24px" >去税保费合计：{{cleanPremiumTotal}}</span>
        <span style="margin-left: 24px" >总佣金合计：{{brokerageTotal}}</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <template slot="statusSlot" slot-scope="text, record">
          <span>{{getStatus(record)}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>
<!--          <a @click="updateStatus(record,'1')" >退回</a>-->
          <!--<a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.status==11" >
                <a v-has="'businessInfoAudit:audit'" @click="updateStatus(record)" >审核开票</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <biz-businessinfo-complete-modal ref="modalForm" @ok="modalFormOk"></biz-businessinfo-complete-modal>

    <a-modal ref="invoiceModal" v-if="invoiceModalVisible" :visible.sync="invoiceModalVisible" title="发票信息" @ok="handleOk" @cancel="handleCancel">
      <biz-businessinfo-invoice-form :businessinfoId="businessinfoId">
      </biz-businessinfo-invoice-form>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction, postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import BizBusinessinfoCompleteModal from './modules/BizBusinessinfoCompleteModal'
  import BizBusinessinfoInvoiceForm from './modules/BizBusinessinfoInvoiceForm'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import {NewBusinessTypeDictOptions} from '../enums/businessTypeDictOptions'

  // 业绩状态 10补录中 11已确认 12 已审核（待推送）
  const BMS_BUSINESS_STATUS_UNFIX = '10'
  const BMS_BUSINESS_STATUS_SUBMIT = '4'
  const BMS_BUSINESS_STATUS_READY = '11'
  const BMS_BUSINESS_STATUS_PASS = '12'

  export default {
    name: 'BizBusinessinfoAuditList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      BizBusinessinfoCompleteModal,
      JDate,
      BizBusinessinfoInvoiceForm,
    },
    data () {
      return {
        description: '业绩审核列表',
        disableMixinCreated: true,
        invoiceModalVisible: false,
        newBusinessTypeDictOptions:[],
        businessinfoId: '',
        brokerageTotal: 0.0, // 合计
        cleanPremiumTotal: 0.0,
        premiumTotal: 0.0,
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'业绩编号',
            className:'column-text',
            dataIndex: 'businessNumber',
            sorter: true
          },
          {
            title:'业绩状态',
            align:"center",
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title:'业务类型',
            align:"center",
            dataIndex: 'businessType_dictText'
          },
          {
            title:'标的类型',
            align:"center",
            dataIndex: 'productOrLife_dictText'
          },
          /*{
            title:'业绩类型',
            align:"center",
            dataIndex: 'businessPerformanceType_dictText'
          },*/
          {
            title:'项目',
            className:"column-text",
            dataIndex: 'project_dictText'
          },
          {
            title:'经纪人',
            align:"center",
            dataIndex: 'createBy_dictText',
            sorter: true
          },
          {
            title:'部门',
            className:"column-text",
            dataIndex: 'sysOrgCode_dictText',
            sorter: true
          },
          {
            title:'投保人',
            className:"column-text",
            dataIndex: 'insure'
          },
          {
            title:'被保险人',
            className:"column-text",
            dataIndex: 'insured'
          },
          {
            title:'保险人',
            className:"column-text",
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'车牌号',
            className:'column-text',
            dataIndex: 'car'
          },
          {
            title:'保险起期',
            className:"column-text",
            dataIndex: 'insuranceStart',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保险讫期',
            className:'column-text',
            dataIndex: 'insuranceEnd',
            sorter: true,
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'保单号',
            className:'column-text',
            dataIndex: 'policy',
            sorter: true
          },
          {
            title:'保额',
            className:'column-money',
            dataIndex: 'insuredAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'费率',
            className:'column-money',
            dataIndex: 'rate',
            customRender:function (text) {
              return !text ? '': text + '‰'
            }
          },
          {
            title:'保费',
            className:'column-money',
            dataIndex: 'premium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'去税保费',
            className:'column-money',
            dataIndex: 'cleanPremium',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          {
            title:'是否含税',
            align:"center",
            dataIndex: 'includeTax_dictText'
          },
          {
            title:'缴费类型',
            align:"center",
            dataIndex: 'lifeInsurancePayType_dictText'
          },
          {
            title:'佣金比例',
            className:'column-money',
            dataIndex: 'brokerageRatio',
            customRender:function (text) {
              return text == null? '': text + '%'
            }
          },
          {
            title:'总佣金',
            className:'column-money',
            dataIndex: 'brokerageTotal',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          // {
          //   title:'开票比例',
          //   className:'column-money',
          //   dataIndex: 'invoiceRatio',
          //   customRender:function (text) {
          //     return text == null ? '': text + '%'
          //   }
          // },
          {
            title:'票外金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'outsideInvoiceAmount',
            customRender:function (text) {
              return !text ? '': text.toLocaleString()
            }
          },
          // V4
          {
            title:'开票编号',
            className:'column-text',
            dataIndex: 'invoiceNumber'
          },
          {
            title:'开票单位', //九安、 九安分公司
            className:'column-text',
            dataIndex: 'invoiceUnit_dictText',
          },
          {
            title:'期数',
            align:"center",
            dataIndex: 'phase'
          },
/*          {
            title:'合作机构',
            className:'column-text',
            dataIndex: 'institution_dictText'
          },*/
          {
            title:'区域',
            className:'column-text',
            dataIndex: 'zone'
          },
          {
            title:'创建日期',
            className:'column-text',
            dataIndex: 'createTime'
          },
          {
            title:'协议附件',
            align:"center",
            dataIndex: 'file',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],

        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['5','10', '50', '100','1000'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },

        url: {
          list: "/bms/bizBusinessinfoComplete/list",
          getMoneyTotal: '/bms/bizBusinessinfoComplete/getMoneyTotal', // 查询合计数
          updateStatus: "/bms/bizBusinessinfoComplete/updateStatus", // 单条状态改变
          batchAuditAndInvoice: "/bms/bizBusinessinfoComplete/batchAuditAndInvoice", // 批量审核开票
          allIds: "/bms/bizBusinessinfoComplete/allIds",//获取所有业绩id（多页）
          batchConfirm:"/bms/bizBusinessinfoComplete/batchConfirm", // 批量审核/确认/提交审核
        },
      }
    },
    created() {
      this.newBusinessTypeDictOptions = NewBusinessTypeDictOptions
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      handleInvoiceInfo(record){
        this.businessinfoId = record.id
        this.invoiceModalVisible = true
      },
      getStatus(record){
        if(record.status == BMS_BUSINESS_STATUS_UNFIX){
          return "补录中"
        } else if(record.status == BMS_BUSINESS_STATUS_SUBMIT) {
          return "已提交"
        }else if(record.status == BMS_BUSINESS_STATUS_READY){
          return "已确认"
        } else if(record.status == BMS_BUSINESS_STATUS_PASS){
          return "已推送"
        } else {
          return "未知"
        }
      },

      getQueryParams() {
        /*if(!this.queryParam.insurerNumber || !this.queryParam.insured){
          this.$message.warning('保险公司和被保人不能为空')
          return false;
        }*/

        //使用高级查询方式插入默认条件 1. status=11  数据库字段为varchar; 2. source='platform'
        if(!this.queryParam.status) {
          this.$message.warning("请选择业绩状态")
          return
        }
        let supQueryObj = [{rule:'eq', type:'string', val:'platform', field: 'source'}]
        let superQueryParams = JSON.stringify(supQueryObj);
        let sqp = {
          superQueryParams: encodeURI(superQueryParams),
          superQueryMatchType: 'and'
        }

        let param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters)

        if(param.insured){
          param.insured = `*${param.insured.trim()}*` // 被保人模糊匹配
        }
        // if(param.insure){
        //   param.insure = `*${param.insure.trim()}*` // 投保人模糊匹配
        // }
        if(param.policy){
          param.policy = `*${param.policy.trim()}*` // 保单号模糊匹配
        }
        // if(param.insuranceName){
        //   param.insuranceName = `*${param.insuranceName.trim()}*` // 险种名称模糊匹配
        // }
        if(param.car){
          param.car = `*${param.car}*` // 车牌号模糊查询
        }
        // 导入日期
        if(param.createTime){
          param.createTime_begin = param.createTime + ' 00:00:00'
          param.createTime_end = param.createTime + ' 23:59:59'
          delete param.createTime
        }
        //保险起期
        if(param.insuranceStartRange && param.insuranceStartRange[0]){
          param.insuranceStart_begin = param.insuranceStartRange[0] + ' 00:00:00'
          param.insuranceStart_end = param.insuranceStartRange[1] + ' 23:59:59'
        }
        delete param.insuranceStartRange
        //保险讫期
        if(param.insuranceEndRange && param.insuranceEndRange[0]){
          param.insuranceEnd_begin = param.insuranceEndRange[0] + ' 00:00:00'
          param.insuranceEnd_end = param.insuranceEndRange[1] + ' 23:59:59'
        }
        delete param.insuranceEndRange

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      loadData(arg) {

        if (arg == 1) {
          this.ipagination.current = 1
          this.onClearSelected()
        }
        let params = this.getQueryParams();
        if(!params){
          return
        }

        this.loading = true
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;

            if(this.ipagination.current === 1){
              //删除排序条件
              delete params.column
              delete params.order
              //delete params.superQueryParams // status字段类型不对，后台sql重新拼写
              //delete params.superQueryMatchType
              getAction(this.url.getMoneyTotal, params).then((result)=>{
                if (result.success) {
                  this.brokerageTotal = !result.result.brokerageTotal ? '': result.result.brokerageTotal.toLocaleString()
                  this.cleanPremiumTotal = !result.result.cleanPremiumTotal ? '': result.result.cleanPremiumTotal.toLocaleString()
                  this.premiumTotal = !result.result.premiumTotal ? '': result.result.premiumTotal.toLocaleString()
                }
              })

              let allIds = new Object();
              getAction(this.url.allIds, params).then((result)=>{
                if (result.success) {
					//console.log(result);
                  this.allIds = !result.result ? '': result.result;
                }
              })
            }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      //单条更新状态,审核或退回
      updateStatus(record, type){
        if(record === undefined || record === null){
          return
        }
        let status = BMS_BUSINESS_STATUS_PASS;
        if(type == '1'){ //退回 到补录状态
          status = BMS_BUSINESS_STATUS_UNFIX
        }
        let param = {id: record.id, status: status}
        postAction(this.url.updateStatus, param).then((res) =>{
          if(res.success){
            this.$message.info(res.result)
            this.loadData()
          } else {
            this.$message.warn(res.message)
          }
        })
      },

      // 批量审核
      batchAudit(){
        let params = this.allIds;
        if(this.dataSource.length <=0){
          return
        }

        if(this.selectedRowKeys.length <=0){ //未选择特定行，全部审核
          const that = this
          // 全部审核
          this.$confirm({
            title: '提示',
            content: '全部'+ that.ipagination.total +'条业绩审核开票？',
            onOk() {
			  //console.log(params);
              that.doBatchAudit(that, {idList: params})
            }
          });

        } else {
          const that = this
          // 部分审核
          this.$confirm({
            title: '提示',
            content: '操作当前选择的'+ that.selectedRowKeys.length +'条业绩？',
            onOk() {
              that.doBatchAudit(that, {idList: that.selectedRowKeys})
            }
          });
        }
      },

      doBatchAudit(that, params){
        //console.log(params);
        postAction(that.url.batchAuditAndInvoice, params).then((res) =>{
          if(res.success){
            that.$message.info(res.result)
            that.loadData()
          } else {
            that.$message.warn(res.message)
          }
        })
      },

      handleCancel(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },

      handleOk(){
        this.$nextTick(()=> {
          this.invoiceModalVisible = false
        })
      },
      // 导入日期选择
      onStartDateChange: function (value, dateString) {
        this.queryParam.insuranceStartRange = dateString;
      },
      // 导入日期选择
      onEndDateChange: function (value, dateString) {
        this.queryParam.insuranceEndRange = dateString;
      },
      // 批量确认
      batchConfirm(status){
        // 未选择，暂不允许将所有符合查询条件的记录都提交审核
        if(this.selectedRowKeys.length <=0){
          this.$message.warning("请先选择业绩")
          return
        }

        //批量确认
        let param = {idList: this.selectedRowKeys, status: status}
        postAction(this.url.batchConfirm, param).then((res) =>{
          if(res.success){
            this.$message.info(res.message)
            this.loadData(1)
          } else {
            this.$message.warn(res.message)
          }
        })
      },

    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>